<template>
    <framework>
        <template #side>
            <course-side-nav v-if="!loading"/>
        </template>
        <template #main>
            <div class="content-frame content pl-5 pt-6" v-if="loading">
                <h4 class="has-text-white"><i class="fas fa-spinner fa-spin mr-4"></i>Please wait. Loading content...</h4>
            </div>

            <template v-else>
                <b-message
                    type="is-danger"
                    v-if="enrollment.course.test_mode"
                >
                    <div class="columns">
                        <div class="column">
                            <strong>Notice:</strong> This course is currently in test mode.
                        </div>
                        <div class="column has-text-right is-narrow">
                            <b-button type="is-danger" size="is-small" @click="testReset"><i class="fas fa-rotate-left mr-2"></i>Reset Enrollment</b-button>
                        </div>
                    </div>

                </b-message>
                <main-header :title="enrollment.course.title" icon="fa-chalkboard-teacher" close="Close Course" :closeRoute="{name: 'enrollments'}"/>
                <router-view/>
            </template>
        </template>
    </framework>
</template>

<script>
    import Framework from "../../components/framework/Framework";
    import CourseSideNav from "../../components/course/CourseSideNav.vue";
    import MainHeader from "../../components/framework/MainHeader";

    import {mapActions, mapGetters} from "vuex";
    import {client as http} from "../../http_client";

    export default {
        components: {Framework, CourseSideNav, MainHeader},
        props: ['enrollmentId'],
        data: function() {
            return {
                loading: true
            };
        },
        computed: {
            ...mapGetters(['enrollment']),
        },
        methods: {
            ...mapActions(['getEnrollmentById']),
            load: function() {
                if (!this.enrollment || this.enrollment.id !== parseInt(this.enrollmentId)) {
                    console.log('Did not find enrollment in store or id changed. Loading from server.');

                    this.getEnrollmentById(this.enrollmentId).then((enroll) => {
                        // this.setColors({
                        //     primary: this.enrollment.course.organization.primary_color,
                        //     background1: this.enrollment.course.organization.background_color_1,
                        //     background2: this.enrollment.course.organization.background_color_2,
                        // });
                        this.loading = false;
                    }).catch(err => {
                        console.log(err);
                    });
                } else {
                    this.loading = false;
                }
            },
            testReset: function() {
                if (confirm('Are you sure you want to reset this enrollment? This will remove all progress.')) {
                    http.post('app/enrollments/' + this.enrollment.id + '/reset').then(() => {
                        this.getEnrollmentById(this.enrollment.id);
                    }).catch(err => {
                        console.log(err);
                    });
                }
            }
        },
        mounted() {
            this.load();
        },
    };
</script>

<style lang="scss" scoped>

</style>
